import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navigaton from "./Routes/Index.jsx";
import '../src/Styles/styles.css'
import '../src/Styles/cards.css'

function App() {
  return (
    <>
      <Navigaton/>
    </>
  );
}

export default App;
